module.exports = __webpack_public_path__ + "static/pi-77e93b0b448519a4fd3d762392ad0032.png";